import { fetcher } from "../fetcher";
import { checkboxesSchema } from "../schemas";
import type { SetCheckboxStatusPayload } from "../types";

type GetCheckboxParams = {
  client_project_id: number; // The id of an existing record in the client_projects table. Example: 1
  order_by?:
    | "id"
    | "name"
    | "deadline_date"
    | "status"
    | "status_changed_at"
    | "created_at"
    | "updated_at";
};

export const checkboxService = {
  getCheckbox: async (params?: GetCheckboxParams) => {
    const paramsWithDefaults = {
      ...params,
      order_by: params?.order_by ?? ("deadline_date" as const),
    };

    return await fetcher(`/checkboxes/all`, {
      method: "GET",
      params: paramsWithDefaults,
      schema: checkboxesSchema,
    });
  },
  setCheckboxStatus: async (payload: SetCheckboxStatusPayload) => {
    const { status, checkbox_id, ...rest } = payload;
    return await fetcher(`/checkboxes/${checkbox_id}/change-status`, {
      method: "POST",
      body: { status: status, ...rest },
    });
  },
};
